import { useCallback, useMemo } from 'react';
import UnifiedTopBar from '@frontend/Components/TopBar';
import { createListViewTemplate } from '@frontend/Components/TopBar/templates';

const buildSearchColumns = () => ({
  Invoices: 'Invoices',
  'Created At': 'Created At',
  'Due Date': 'Due Date',
  'Total Amount': 'Total Amount',
  'Amount Paid': 'Amount Paid',
});

interface InvoiceTopBarProps {
  setActivePage?: (page: string) => void;
  onSearch?: (searchTerm: string, column?: string | null) => void;
}

const InvoiceTopBar: React.FC<InvoiceTopBarProps> = ({ onSearch }) => {
  const searchColumns = useMemo(buildSearchColumns, []);

  const unifiedConfig = createListViewTemplate({
    search: onSearch
      ? {
          columns: searchColumns,
          defaultSelectedColumn: 'Invoices',
          onSearch,
          placeholder: 'Search invoices',
        }
      : undefined,
    pageContext: {
      route: 'financial-invoice',
    },
  });

  return <UnifiedTopBar {...unifiedConfig} />;
};

export default InvoiceTopBar;
